module.exports = __webpack_public_path__ + "img/1491810768.d546abed.jpg";